import React, { useState } from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown, Send, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
// --- DATA ---
type Status = 'Sous la cible' | 'À surveiller' | 'Conforme';
interface ServiceData {
  id: string;
  service: string;
  serviceEn: string;
  category: string;
  categoryEn: string;
  target: string;
  targetEn: string;
  performance: number;
  status: Status;
}
const initialData: ServiceData[] = [{
  id: '1',
  service: 'Éclairage de parc',
  serviceEn: 'Park lighting',
  category: 'Éclairage',
  categoryEn: 'Lighting',
  target: '21 jours',
  targetEn: '21 days',
  performance: 33,
  status: 'Sous la cible'
}, {
  id: '2',
  service: 'Réparation lampadaire',
  serviceEn: 'Streetlight repair',
  category: 'Éclairage',
  categoryEn: 'Lighting',
  target: '21 jours',
  targetEn: '21 days',
  performance: 46,
  status: 'Sous la cible'
}, {
  id: '3',
  service: 'Signalisation routière',
  serviceEn: 'Road signage',
  category: 'Voirie',
  categoryEn: 'Roads',
  target: '180 jours',
  targetEn: '180 days',
  performance: 71,
  status: 'À surveiller'
}, {
  id: '4',
  service: 'Nid-de-poule',
  serviceEn: 'Pothole',
  category: 'Voirie',
  categoryEn: 'Roads',
  target: '7 jours',
  targetEn: '7 days',
  performance: 77,
  status: 'À surveiller'
}, {
  id: '5',
  service: 'Suivi permis',
  serviceEn: 'Permit tracking',
  category: 'Permis',
  categoryEn: 'Permits',
  target: '14 jours',
  targetEn: '14 days',
  performance: 86,
  status: 'Conforme'
}];
export interface ImpactedService {
  name: string;
  nameEn: string;
  requests: number;
  sla: number;
}
export interface District {
  id: string;
  name: string;
  nameEn: string;
  label: string;
  sla: number;
  totalRequests: number;
  reachable: number;
  activeCards: number;
  openRate: number;
  impactedServices: ImpactedService[];
  points: string;
  labelX: number;
  labelY: number;
}
const districts: District[] = [{
  id: 'A',
  name: 'Secteur A',
  nameEn: 'District A',
  label: 'A',
  sla: 46,
  totalRequests: 412,
  reachable: 83,
  activeCards: 4182,
  openRate: 71,
  impactedServices: [{
    name: 'Éclairage',
    nameEn: 'Lighting',
    requests: 163,
    sla: 46
  }, {
    name: 'Signalisation routière',
    nameEn: 'Road signage',
    requests: 124,
    sla: 71
  }, {
    name: 'Collecte des ordures',
    nameEn: 'Waste collection',
    requests: 88,
    sla: 79
  }],
  points: '20,20 200,20 200,160 20,160',
  labelX: 110,
  labelY: 95
}, {
  id: 'B',
  name: 'Secteur B',
  nameEn: 'District B',
  label: 'B',
  sla: 58,
  totalRequests: 287,
  reachable: 76,
  activeCards: 3214,
  openRate: 64,
  impactedServices: [{
    name: 'Réparation lampadaire',
    nameEn: 'Streetlight repair',
    requests: 102,
    sla: 41
  }, {
    name: 'Nid-de-poule',
    nameEn: 'Pothole',
    requests: 71,
    sla: 68
  }, {
    name: 'Graffitis',
    nameEn: 'Graffiti',
    requests: 48,
    sla: 73
  }],
  points: '200,20 400,20 400,160 200,160',
  labelX: 300,
  labelY: 95
}, {
  id: 'C',
  name: 'Secteur C',
  nameEn: 'District C',
  label: 'C',
  sla: 84,
  totalRequests: 196,
  reachable: 88,
  activeCards: 2876,
  openRate: 79,
  impactedServices: [{
    name: 'Nid-de-poule',
    nameEn: 'Pothole',
    requests: 58,
    sla: 81
  }, {
    name: 'Collecte des ordures',
    nameEn: 'Waste collection',
    requests: 47,
    sla: 88
  }, {
    name: 'Suivi permis',
    nameEn: 'Permit tracking',
    requests: 33,
    sla: 86
  }],
  points: '400,20 580,20 580,160 400,160',
  labelX: 490,
  labelY: 95
}, {
  id: 'L',
  name: 'Secteur L',
  nameEn: 'District L',
  label: 'L',
  sla: 71,
  totalRequests: 318,
  reachable: 81,
  activeCards: 3654,
  openRate: 68,
  impactedServices: [{
    name: 'Signalisation routière',
    nameEn: 'Road signage',
    requests: 118,
    sla: 67
  }, {
    name: 'Éclairage de parc',
    nameEn: 'Park lighting',
    requests: 82,
    sla: 52
  }, {
    name: 'Nid-de-poule',
    nameEn: 'Pothole',
    requests: 64,
    sla: 76
  }],
  points: '20,160 200,160 200,300 20,300',
  labelX: 110,
  labelY: 235
}, {
  id: 'M',
  name: 'Secteur M',
  nameEn: 'District M',
  label: 'M',
  sla: 67,
  totalRequests: 351,
  reachable: 79,
  activeCards: 3982,
  openRate: 66,
  impactedServices: [{
    name: 'Éclairage',
    nameEn: 'Lighting',
    requests: 134,
    sla: 54
  }, {
    name: 'Signalisation routière',
    nameEn: 'Road signage',
    requests: 96,
    sla: 69
  }, {
    name: 'Collecte des ordures',
    nameEn: 'Waste collection',
    requests: 67,
    sla: 82
  }],
  points: '200,160 400,160 400,300 200,300',
  labelX: 300,
  labelY: 235
}, {
  id: 'O',
  name: 'Secteur O',
  nameEn: 'District O',
  label: 'O',
  sla: 89,
  totalRequests: 142,
  reachable: 91,
  activeCards: 2412,
  openRate: 82,
  impactedServices: [{
    name: 'Suivi permis',
    nameEn: 'Permit tracking',
    requests: 41,
    sla: 90
  }, {
    name: 'Collecte des ordures',
    nameEn: 'Waste collection',
    requests: 36,
    sla: 92
  }, {
    name: 'Nid-de-poule',
    nameEn: 'Pothole',
    requests: 28,
    sla: 85
  }],
  points: '400,160 580,160 580,300 400,300',
  labelX: 490,
  labelY: 235
}, {
  id: 'R',
  name: 'Secteur R',
  nameEn: 'District R',
  label: 'R',
  sla: 77,
  totalRequests: 224,
  reachable: 84,
  activeCards: 2987,
  openRate: 73,
  impactedServices: [{
    name: 'Nid-de-poule',
    nameEn: 'Pothole',
    requests: 78,
    sla: 74
  }, {
    name: 'Graffitis',
    nameEn: 'Graffiti',
    requests: 52,
    sla: 78
  }, {
    name: 'Collecte des ordures',
    nameEn: 'Waste collection',
    requests: 41,
    sla: 86
  }],
  points: '20,300 300,300 300,400 20,400',
  labelX: 160,
  labelY: 355
}, {
  id: 'S',
  name: 'Secteur S',
  nameEn: 'District S',
  label: 'S',
  sla: 82,
  totalRequests: 187,
  reachable: 86,
  activeCards: 2614,
  openRate: 75,
  impactedServices: [{
    name: 'Signalisation routière',
    nameEn: 'Road signage',
    requests: 62,
    sla: 78
  }, {
    name: 'Nid-de-poule',
    nameEn: 'Pothole',
    requests: 49,
    sla: 84
  }, {
    name: 'Suivi permis',
    nameEn: 'Permit tracking',
    requests: 31,
    sla: 88
  }],
  points: '300,300 580,300 580,400 300,400',
  labelX: 440,
  labelY: 355
}];
function getStatusForSla(sla: number): 'critical' | 'warning' | 'on-track' {
  if (sla < 60) return 'critical';
  if (sla < 80) return 'warning';
  return 'on-track';
}
// --- COMPONENTS ---
function KPIGrid() {
  const {
    t
  } = useLanguage();
  return <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-4809" data-mp="23gm0he7efypz">
      <div className="border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col gap-2 bg-white" data-id="element-4810" data-mp="1pmuyqrzwtj4t">
        <div className="text-sm font-medium text-slate-500 font-body" data-id="element-4811" data-mp="1ukwhtcxc5iga">
          {t('Requêtes reçues', 'Requests received')}
        </div>
        <div className="text-3xl font-bold text-[#0F172A] font-heading" data-id="element-4812" data-mp="2n2s1h0w205j6">
          60 058
        </div>
        <div className="text-sm text-slate-500 font-body" data-id="element-4813" data-mp="n08xzfov7dps">
          {t('+11 % vs mois précédent', '+11% vs. previous month')}
        </div>
      </div>
      <div className="border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col gap-2 bg-white" data-id="element-4814" data-mp="i87r69aguf75">
        <div className="text-sm font-medium text-slate-500 font-body" data-id="element-4815" data-mp="db8upk3bxw5s">
          {t('Résolues dans les délais', 'Resolved on time')}
        </div>
        <div className="text-3xl font-bold text-[#0F172A] font-heading" data-id="element-4816" data-mp="15z4q8lh5xi0z">
          81 %
        </div>
        <div className="text-sm text-emerald-600 font-medium font-body" data-id="element-4817" data-mp="110jt4ux7jegr">
          {t('+10 points', '+10 points')}
        </div>
      </div>
      <div className="border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col gap-2 bg-white" data-id="element-4818" data-mp="vzw4gfwgb9pp">
        <div className="text-sm font-medium text-slate-500 font-body" data-id="element-4819" data-mp="rz2cnbfw1arj">
          {t('Services sous la cible', 'Services below target')}
        </div>
        <div className="text-3xl font-bold text-[#0F172A] font-heading" data-id="element-4820" data-mp="3cq2sjginjq7n">2</div>
        <div className="text-sm text-red-600 font-medium font-body" data-id="element-4821" data-mp="3cs76kra9m5ln">
          {t('Action requise', 'Action required')}
        </div>
      </div>
      <div className="border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col gap-2 bg-white" data-id="element-4822" data-mp="1waf888s8wlcn">
        <div className="text-sm font-medium text-slate-500 font-body" data-id="element-4823" data-mp="217fd4gdczi26">
          {t('Services à surveiller', 'Services to watch')}
        </div>
        <div className="text-3xl font-bold text-[#0F172A] font-heading" data-id="element-4824" data-mp="2611hll9dcfmw">3</div>
        <div className="text-sm text-amber-600 font-medium font-body" data-id="element-4825" data-mp="2ay0a5zddweiz">
          {t('Tendance à la baisse', 'Trending down')}
        </div>
      </div>
    </div>;
}
function PerformanceTable() {
  const {
    t,
    lang
  } = useLanguage();
  const [data, setData] = useState(initialData);
  const [sortConfig, setSortConfig] = useState<{
    key: keyof ServiceData;
    direction: 'asc' | 'desc';
  }>({
    key: 'performance',
    direction: 'asc'
  });
  const handleSort = (key: keyof ServiceData) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({
      key,
      direction
    });
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedData);
  };
  const getStatusColor = (status: Status) => {
    switch (status) {
      case 'Sous la cible':
        return 'bg-red-50 text-red-700 border-red-200';
      case 'À surveiller':
        return 'bg-amber-50 text-amber-700 border-amber-200';
      case 'Conforme':
        return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    }
  };
  const statusLabel = (status: Status) => {
    switch (status) {
      case 'Sous la cible':
        return t('Sous la cible', 'Below target');
      case 'À surveiller':
        return t('À surveiller', 'To watch');
      case 'Conforme':
        return t('Conforme', 'On track');
    }
  };
  const getBarColor = (performance: number) => {
    if (performance < 60) return 'bg-red-500';
    if (performance < 80) return 'bg-amber-500';
    return 'bg-emerald-500';
  };
  const SortIcon = ({
    columnKey
  }: {
    columnKey: keyof ServiceData;
  }) => {
    if (sortConfig.key !== columnKey) return <ArrowUpDown className="w-3 h-3 text-slate-300 ml-1 inline-block" data-id="element-4826" data-mp="3sxpju4bu9okv" />;
    return sortConfig.direction === 'asc' ? <ArrowUp className="w-3 h-3 text-slate-600 ml-1 inline-block" data-id="element-4827" data-mp="uesek2ysjdc2" /> : <ArrowDown className="w-3 h-3 text-slate-600 ml-1 inline-block" data-id="element-4828" data-mp="pg7ec3jjgtnm" />;
  };
  return <div className="border border-slate-200 rounded-xl shadow-sm overflow-hidden bg-white" data-id="element-4829" data-mp="kpqvu50v2hue">
      <table className="w-full text-left text-sm whitespace-nowrap font-body" data-id="element-4830" data-mp="fr7ao6u3da33">
        <thead className="bg-slate-50 border-b border-slate-200 text-slate-600" data-id="element-4831" data-mp="fp38pufr6l5g">
          <tr data-id="element-4832" data-mp="1d7mje42p9p2k">
            <th className="px-4 py-3 font-medium cursor-pointer hover:bg-slate-100 transition-colors" onClick={() => handleSort('service')} data-id="element-4833" data-mp="1d84ozrb95fn5">
              {t('Service', 'Service')} <SortIcon columnKey="service" data-id="element-4834" data-mp="36p0w5ukzncx0" />
            </th>
            <th className="px-4 py-3 font-medium cursor-pointer hover:bg-slate-100 transition-colors" onClick={() => handleSort('category')} data-id="element-4835" data-mp="36oiugifk46hp">
              {t('Catégorie', 'Category')} <SortIcon columnKey="category" data-id="element-4836" data-mp="2xum7x2ihcs1r" />
            </th>
            <th className="px-4 py-3 font-medium cursor-pointer hover:bg-slate-100 transition-colors" onClick={() => handleSort('target')} data-id="element-4837" data-mp="2iyenc135toly">
              {t('Délai cible', 'Target time')} <SortIcon columnKey="target" data-id="element-4838" data-mp="2a0ch974kk5rt" />
            </th>
            <th className="px-4 py-3 font-medium cursor-pointer hover:bg-slate-100 transition-colors w-64" onClick={() => handleSort('performance')} data-id="element-4839" data-mp="2excm5epon2hc">
              {t('Performance réelle', 'Actual performance')}{' '}
              <SortIcon columnKey="performance" data-id="element-4840" data-mp="d4f0c2ubpa5w" />
            </th>
            <th className="px-4 py-3 font-medium cursor-pointer hover:bg-slate-100 transition-colors" onClick={() => handleSort('status')} data-id="element-4841" data-mp="nb7vf1m6enj2">
              {t('État', 'Status')} <SortIcon columnKey="status" data-id="element-4842" data-mp="w3jjigtthyvv" />
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100" data-id="element-4843" data-mp="rayr9jqk7tug">
          {data.map(row => <tr key={row.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-4844" data-mp="1604pb4dnve0r">
              <td className="px-4 py-3 font-medium text-[#0F172A]" data-id="element-4845" data-mp="112352g4i18np">
                {lang === 'fr' ? row.service : row.serviceEn}
              </td>
              <td className="px-4 py-3 text-slate-500" data-id="element-4846" data-mp="1f12nh61f4rbf">
                {lang === 'fr' ? row.category : row.categoryEn}
              </td>
              <td className="px-4 py-3 text-slate-500" data-id="element-4847" data-mp="3gsz3osyj6pcj">
                {lang === 'fr' ? row.target : row.targetEn}
              </td>
              <td className="px-4 py-3" data-id="element-4848" data-mp="3csf8vw1fjxtk">
                <div className="flex items-center gap-3" data-id="element-4849" data-mp="3ctgp0exazai5">
                  <div className="w-32 h-1.5 bg-slate-100 rounded-full overflow-hidden" data-id="element-4850" data-mp="3e7hqi5xpcyxh">
                    <div className={`h-full rounded-full ${getBarColor(row.performance)}`} style={{
                  width: `${row.performance}%`
                }} data-id="element-4851" data-mp="3j6uit67cey7g" />
                  </div>
                  <span className="text-slate-700 font-medium w-10" data-id="element-4852" data-mp="2vi1otfaa70fh">
                    {row.performance} %
                  </span>
                </div>
              </td>
              <td className="px-4 py-3" data-id="element-4853" data-mp="2zhk6812w8tdk">
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(row.status)}`} data-id="element-4854" data-mp="34i7u4dvtsu3k">
                  {statusLabel(row.status)}
                </span>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}
function HeatMap({
  districts,
  selectedId,
  onSelect
}: {
  districts: District[];
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  const {
    t
  } = useLanguage();
  const fillFor = (sla: number, selected: boolean) => {
    const status = getStatusForSla(sla);
    if (status === 'critical') return selected ? '#DC2626' : '#FCA5A5';
    if (status === 'warning') return selected ? '#D97706' : '#FCD34D';
    return selected ? '#059669' : '#A7F3D0';
  };
  return <div className="border border-slate-200 rounded-xl shadow-sm bg-white p-4 flex flex-col gap-3 h-full" data-id="element-4855" data-mp="1qb1qoagp2e70">
      <div className="flex items-center justify-between" data-id="element-4856" data-mp="1lj0jv42apfod">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wide font-body" data-id="element-4857" data-mp="1gkyobjnonnw0">
          {t('Carte des secteurs · Windsor', 'District map · Windsor')}
        </div>
        <div className="flex items-center gap-3 text-xs text-slate-500 font-body" data-id="element-4858" data-mp="1bjsvllu0w0mh">
          <div className="flex items-center gap-1.5" data-id="element-4859" data-mp="17jr05uevs3fn">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#FCA5A5] border border-red-300" data-id="element-4860" data-mp="12kny8iu76dbw"></span>
            {t('Sous la cible', 'Below target')}
          </div>
          <div className="flex items-center gap-1.5" data-id="element-4861" data-mp="szoe28u7azze">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#FCD34D] border border-amber-300" data-id="element-4862" data-mp="x088v5raxrid"></span>
            {t('À surveiller', 'To watch')}
          </div>
          <div className="flex items-center gap-1.5" data-id="element-4863" data-mp="j1qptlccd36s">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#A7F3D0] border border-emerald-300" data-id="element-4864" data-mp="nza24fphb5w3"></span>
            {t('Conforme', 'On track')}
          </div>
        </div>
      </div>
      <svg viewBox="0 0 600 420" className="w-full h-auto mt-auto mb-auto" role="img" aria-label={t('Carte de chaleur des secteurs de Windsor', 'Heat map of Windsor districts')} data-id="element-4865" data-mp="1gnfn93kg2wwg">
        {districts.map(d => {
        const selected = d.id === selectedId;
        return <g key={d.id} onClick={() => onSelect(d.id)} className="cursor-pointer group" data-id="element-4866" data-mp="1ukujos9484xx">
              <polygon points={d.points} fill={fillFor(d.sla, selected)} stroke={selected ? '#0F172A' : '#ffffff'} strokeWidth={selected ? 3 : 2} className="transition-all" data-id="element-4867" data-mp="3k39jqbzfkrqd" />
              <text x={d.labelX} y={d.labelY} textAnchor="middle" dominantBaseline="middle" className="pointer-events-none select-none" fill="#0F172A" fontSize="22" fontWeight="bold" fontFamily="sans-serif" data-id="element-4868" data-mp="3ourjiwppwm9r">
                {d.label}
              </text>
              <text x={d.labelX} y={d.labelY + 22} textAnchor="middle" dominantBaseline="middle" className="pointer-events-none select-none" fill="#0F172A" fontSize="12" opacity="0.7" fontFamily="sans-serif" data-id="element-4869" data-mp="35722nkjbk6fb">
                {d.sla} %
              </text>
            </g>;
      })}
      </svg>
    </div>;
}
function DistrictDetailPanel({
  district
}: {
  district: District;
}) {
  const {
    t,
    lang
  } = useLanguage();
  const statusBadge = (sla: number) => {
    const status = getStatusForSla(sla);
    if (status === 'critical') return 'bg-red-50 text-red-700 border-red-200';
    if (status === 'warning') return 'bg-amber-50 text-amber-700 border-amber-200';
    return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  };
  const statusLabel = (sla: number) => {
    const status = getStatusForSla(sla);
    if (status === 'critical') return t('Sous la cible', 'Below target');
    if (status === 'warning') return t('À surveiller', 'To watch');
    return t('Conforme', 'On track');
  };
  const barColor = (sla: number) => {
    const status = getStatusForSla(sla);
    if (status === 'critical') return 'bg-red-500';
    if (status === 'warning') return 'bg-amber-500';
    return 'bg-emerald-500';
  };
  const districtName = lang === 'fr' ? district.name : district.nameEn;
  const buildRecommendation = (d: District) => {
    const worst = d.impactedServices[0];
    const worstName = lang === 'fr' ? worst.name : worst.nameEn;
    const status = getStatusForSla(d.sla);
    if (status === 'on-track') {
      return {
        headline: t(`Performance conforme dans le ${d.name.toLowerCase()}.`, `On-track performance in ${d.nameEn}.`),
        body: t(`Aucune intervention de communication n'est requise pour le moment. ${d.reachable} % des citoyens du secteur restent joignables via les canaux numériques bciti+ si une situation venait à évoluer.`, `No communication action is required at this time. ${d.reachable}% of the district's citizens remain reachable via the bciti+ digital channels should a situation arise.`)
      };
    }
    const reachQualifier = d.reachable >= 80 ? t('très bien', 'very well') : d.reachable >= 65 ? t('majoritairement', 'mostly') : t('partiellement', 'partially');
    return {
      headline: t(`${worst.name} sous pression dans le ${d.name.toLowerCase()}.`, `${worst.nameEn} under pressure in ${d.nameEn}.`),
      body: t(`Les citoyens de ce secteur sont ${reachQualifier} joignables via les canaux numériques bciti+ (${d.reachable} %). Un avis ciblé concernant ${worst.name.toLowerCase()} pourrait réduire les appels entrants et améliorer la satisfaction citoyenne durant la période d'intervention.`, `Citizens in this district are ${reachQualifier} reachable via the bciti+ digital channels (${d.reachable}%). A targeted notice about ${worstName.toLowerCase()} could reduce inbound calls and improve citizen satisfaction during the intervention period.`)
    };
  };
  const recommendation = buildRecommendation(district);
  return <div className="border border-slate-200 rounded-xl shadow-sm bg-white flex flex-col h-full overflow-hidden font-body" data-id="element-4870" data-mp="8shf0mpvg3sh">
      <div className="px-5 py-4 border-b border-slate-100 flex items-start justify-between gap-4" data-id="element-4871" data-mp="dqiz9az1a95j">
        <div className="flex flex-col gap-1" data-id="element-4872" data-mp="iq58787tx38j">
          <div className="flex items-center gap-2 text-xs text-slate-500 uppercase tracking-wide" data-id="element-4873" data-mp="ioc3hygs0t36">
            <MapPin className="w-3.5 h-3.5" data-id="element-4874" data-mp="nj87zy3798x6" />{' '}
            {t('Secteur sélectionné', 'Selected district')}
          </div>
          <div className="flex items-center gap-3" data-id="element-4875" data-mp="whjt5klarei8">
            <h3 className="text-xl font-bold text-[#0F172A] font-heading" data-id="element-4876" data-mp="wg8rbqbewgtr">
              {districtName}
            </h3>
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${statusBadge(district.sla)}`} data-id="element-4877" data-mp="11etv1zpvhimy">
              {statusLabel(district.sla)}
            </span>
          </div>
        </div>
        <div className="text-right" data-id="element-4878" data-mp="388dzufzebg4z">
          <div className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-4879" data-mp="389griq4jlmly">
            {district.sla} %
          </div>
          <div className="text-xs text-slate-500" data-id="element-4880" data-mp="2v7lfsm2avdi4">
            {t(`SLA global · ${district.totalRequests} requêtes`, `Overall SLA · ${district.totalRequests} requests`)}
          </div>
        </div>
      </div>

      <div className="px-5 py-4 border-b border-slate-100 flex flex-col gap-3" data-id="element-4881" data-mp="354yda9cme680">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wide" data-id="element-4882" data-mp="3j4hboafmq374">
          {t('Services les plus touchés', 'Most affected services')}
        </div>
        <ul className="flex flex-col gap-3" data-id="element-4883" data-mp="3sv2k0pl3um38">
          {district.impactedServices.map(svc => <li key={svc.name} className="flex flex-col gap-1.5" data-id="element-4884" data-mp="3nwiw4jmyb088">
              <div className="flex items-center justify-between text-sm" data-id="element-4885" data-mp="3nx0y7wwao8o2">
                <span className="font-medium text-[#0F172A]" data-id="element-4886" data-mp="5rfpguhc6g5p">
                  {lang === 'fr' ? svc.name : svc.nameEn}
                </span>
                <span className="text-slate-500" data-id="element-4887" data-mp="1n7ysrrbiq4u">
                  {t(`${svc.requests} requêtes · `, `${svc.requests} requests · `)}
                  <span className="text-[#0F172A] font-medium" data-id="element-4888" data-mp="pa210qftjdj2">
                    {svc.sla} %
                  </span>
                </span>
              </div>
              <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden" data-id="element-4889" data-mp="gaf2cceh4ltp">
                <div className={`h-full ${barColor(svc.sla)}`} style={{
              width: `${svc.sla}%`
            }} data-id="element-4890" data-mp="1lshxw9zp3vm" />
              </div>
            </li>)}
        </ul>
      </div>

      <div className="px-5 py-4 border-b border-slate-100 flex flex-col gap-3" data-id="element-4891" data-mp="3st4u1ww0mr4o">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wide" data-id="element-4892" data-mp="3sqschku66is5">
          {t('Portée numérique bciti+', 'bciti+ digital reach')}
        </div>
        <div className="grid grid-cols-3 gap-3" data-id="element-4893" data-mp="3jr5bh05crezm">
          <div className="flex flex-col gap-0.5" data-id="element-4894" data-mp="q0gxv4z19ck8">
            <div className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4895" data-mp="pz724mfnkggr">
              {district.reachable} %
            </div>
            <div className="text-xs text-slate-500 leading-tight" data-id="element-4896" data-mp="m198n7eun87k">
              {t('Citoyens joignables', 'Reachable citizens')}
            </div>
          </div>
          <div className="flex flex-col gap-0.5" data-id="element-4897" data-mp="c8alltz03pq2">
            <div className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4898" data-mp="79zazh0vtb6s">
              {district.activeCards.toLocaleString(lang === 'fr' ? 'fr-CA' : 'en-CA')}
            </div>
            <div className="text-xs text-slate-500 leading-tight" data-id="element-4899" data-mp="3ue6qtwtf7szn">
              {t('Cartes citoyennes actives', 'Active citizen cards')}
            </div>
          </div>
          <div className="flex flex-col gap-0.5" data-id="element-4900" data-mp="3phyjh5lgt431">
            <div className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4901" data-mp="1smaiew2juz93">
              {district.openRate} %
            </div>
            <div className="text-xs text-slate-500 leading-tight" data-id="element-4902" data-mp="1np0gwi1vyx4w">
              {t('Ouverture des notifications', 'Notification open rate')}
            </div>
          </div>
        </div>
      </div>

      <div className="px-5 py-4 flex flex-col gap-3 bg-indigo-50/30 flex-1" data-id="element-4903" data-mp="205056vagnlds">
        <div className="flex items-center gap-2" data-id="element-4904" data-mp="24yw1ltb2t06u">
          <div className="w-1.5 h-1.5 rounded-full bg-[#4F46E5]" data-id="element-4905" data-mp="29wo2hctp7wn6" />
          <div className="text-xs font-medium text-slate-500 uppercase tracking-wide" data-id="element-4906" data-mp="29vute579ov1v">
            {t('Recommandation opérationnelle', 'Operational recommendation')}
          </div>
        </div>
        <div className="flex flex-col gap-1.5" data-id="element-4907" data-mp="1h88u3952ockt">
          <p className="text-sm font-bold text-[#0F172A]" data-id="element-4908" data-mp="1m6k3xjvdan31">
            {recommendation.headline}
          </p>
          <p className="text-sm text-slate-600 leading-relaxed" data-id="element-4909" data-mp="1q8x6jzeti4vl">
            {recommendation.body}
          </p>
        </div>
        {getStatusForSla(district.sla) !== 'on-track' && <button className="self-start inline-flex items-center gap-2 px-4 py-2 bg-[#4F46E5] hover:bg-[#4338CA] text-white text-sm font-medium rounded-lg transition-colors shadow-sm mt-2" data-id="element-4910" data-mp="31naqit6ga06c">
            <Send className="w-3.5 h-3.5" data-id="element-4911" data-mp="xk94y5n67gny" />{' '}
            {t("Préparer l'avis citoyen", 'Prepare citizen notice')}
          </button>}
      </div>
    </div>;
}
export function RequetesAnalytics() {
  const {
    t
  } = useLanguage();
  const sortedByWorst = [...districts].sort((a, b) => a.sla - b.sla);
  const [selectedId, setSelectedId] = useState<string>(sortedByWorst[0].id);
  const selected = districts.find(d => d.id === selectedId) ?? districts[0];
  return <div className="space-y-10 animate-in fade-in duration-300" data-id="element-4912" data-mp="erespjgxm2nf">
      <section className="flex flex-col gap-2" data-id="element-4913" data-mp="slo4q67x4wzi">
        <h2 className="text-xl font-bold text-[#0F172A] font-heading" data-id="element-4914" data-mp="nu64xlhmt2g4">
          {t('Performance des services citoyens', 'Citizen service performance')}
        </h2>
        <p className="text-slate-500 text-sm font-body" data-id="element-4915" data-mp="3rb6602d48cud">
          {t('Suivi en temps réel des délais de service et de la performance opérationnelle.', 'Real-time tracking of service turnaround times and operational performance.')}
        </p>
      </section>

      <KPIGrid data-id="element-4916" data-mp="1xs5rt8a6p0g0" />

      <section className="flex flex-col gap-4" data-id="element-4917" data-mp="1xspc2vnb40x7">
        <div className="flex flex-col gap-1" data-id="element-4918" data-mp="1xu0g8wknzaou">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4919" data-mp="22qqxhn87gcbu">
            {t('Performance par service', 'Performance by service')}
          </h2>
          <p className="text-sm text-slate-500 font-body" data-id="element-4920" data-mp="2qeql4ea7zmm7">
            {t('Triés du plus critique au plus conforme', 'Sorted from most critical to most compliant')}
          </p>
        </div>
        <PerformanceTable data-id="element-4921" data-mp="2lhi4wj8mtsnl" />
      </section>

      <section className="flex flex-col gap-4" data-id="element-4922" data-mp="2lg6zkezjgcud">
        <div className="flex flex-col gap-1" data-id="element-4923" data-mp="153ru6tn0c64z">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4924" data-mp="151xa1hjk8i1y">
            {t('Concentration géographique des délais', 'Geographic concentration of delays')}
          </h2>
          <p className="text-sm text-slate-500 font-body" data-id="element-4925" data-mp="21o39n0tiaclq">
            {t('Sélectionnez un secteur pour voir les services concernés et la portée numérique disponible.', 'Select a district to view the affected services and the available digital reach.')}
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6" data-id="element-4926" data-mp="2kge3y6a3h288">
          <div className="lg:col-span-3" data-id="element-4927" data-mp="2kiqkqg4496jp">
            <HeatMap districts={districts} selectedId={selectedId} onSelect={setSelectedId} data-id="element-4928" data-mp="2fh18wy92kouk" />
          </div>
          <div className="lg:col-span-2" data-id="element-4929" data-mp="2aorotyumyj07">
            <DistrictDetailPanel district={selected} data-id="element-4930" data-mp="25sjcsubqj5x9" />
          </div>
        </div>
      </section>

      <div className="border border-slate-200 rounded-xl shadow-sm p-6 flex flex-col gap-4 bg-indigo-50/50 font-body" data-id="element-4931" data-mp="337f1cpvkgppo">
        <div className="flex items-center gap-2" data-id="element-4932" data-mp="2yfn9mc0ocdxy">
          <div className="w-2 h-2 rounded-full bg-[#4F46E5]" data-id="element-4933" data-mp="36p2t6kglfly7"></div>
          <h2 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4934" data-mp="36qw080v4c86q">
            {t('Priorisation assistée par bciti+', 'bciti+ assisted prioritization')}
          </h2>
        </div>
        <div className="flex flex-col md:flex-row gap-6 items-start md:items-center justify-between" data-id="element-4935" data-mp="3koue755j22lp">
          <div className="flex flex-col gap-2 max-w-3xl" data-id="element-4936" data-mp="3pnx9vyzmawh0">
            <p className="text-[#0F172A] font-bold" data-id="element-4937" data-mp="3pnfawulkm45e">
              {t('Réparation des lampadaires sous la cible.', 'Streetlight repair below target.')}
            </p>
            <p className="text-slate-600 leading-relaxed text-sm" data-id="element-4938" data-mp="2cxstcoymee0">
              {t('83 % des citoyens concernés sont joignables via les canaux numériques bciti+. Une communication proactive pourrait réduire les appels entrants et améliorer la satisfaction citoyenne pendant les travaux.', '83% of affected citizens are reachable via the bciti+ digital channels. Proactive communication could reduce inbound calls and improve citizen satisfaction during the work.')}
            </p>
          </div>
          <button className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#4F46E5] hover:bg-[#4338CA] text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-4939" data-mp="19zv7yocoszgn">
            <Send className="w-4 h-4" data-id="element-4940" data-mp="21pzno9pi4ybj" />{' '}
            {t("Préparer l'avis citoyen", 'Prepare citizen notice')}
          </button>
        </div>
      </div>

      <section className="flex flex-col gap-4 pt-4 border-t border-slate-200 font-body" data-id="element-4941" data-mp="26r6ti3833nfk">
        <h2 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-4942" data-mp="1svv0c09ku50r">
          {t('Portée de la plateforme bciti+', 'bciti+ platform reach')}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-4943" data-mp="2ko2hr2wwplg7">
          <div className="flex flex-col gap-1" data-id="element-4944" data-mp="2pfu1athnaqwu">
            <div className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-4945" data-mp="2pgn6hq0yh8cv">
              42 105
            </div>
            <div className="text-sm text-slate-500" data-id="element-4946" data-mp="dz1y0fi6g5y2">
              {t('Identités numériques', 'Digital identities')}
            </div>
          </div>
          <div className="flex flex-col gap-1" data-id="element-4947" data-mp="nr7kxatknx6e">
            <div className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-4948" data-mp="npwgr9w7sner">
              38 902
            </div>
            <div className="text-sm text-slate-500" data-id="element-4949" data-mp="itxpneji4ran">
              {t('Cartes citoyennes actives', 'Active citizen cards')}
            </div>
          </div>
          <div className="flex flex-col gap-1" data-id="element-4950" data-mp="3m9lkctu8vahj">
            <div className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-4951" data-mp="506oouju6fqj">
              86 %
            </div>
            <div className="text-sm text-slate-500" data-id="element-4952" data-mp="1d98wkzoenq">
              {t('Taux de joignabilité numérique', 'Digital reachability rate')}
            </div>
          </div>
          <div className="flex flex-col gap-1" data-id="element-4953" data-mp="1ghg5tafhsvoo">
            <div className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-4954" data-mp="1bh1vtmubzbo0">
              74 %
            </div>
            <div className="text-sm text-slate-500" data-id="element-4955" data-mp="1iinlmriqkj15">
              {t("Taux d'ouverture des notifications", 'Notification open rate')}
            </div>
          </div>
        </div>
      </section>
    </div>;
}